import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Whether the asset-approvals surface is hidden for the current workspace:
 * the whole folders route tree (list, folder detail, asset detail, compare,
 * bulk approve), plus the home asset-reviews tile, the project snapshot tile,
 * the trackers approval column and the sidebar entry. Approval chains are one
 * part of that, not the whole of it — see `useApprovalChainsEnabled`.
 *
 * Polarity is inverted on purpose: on = hide, off = today's behaviour. The
 * flag is a sub-flag of `projects_module` — with the parent off, this has no
 * observable effect because nothing under Projects renders.
 */
export function useAssetApprovalsHidden(): boolean {
  return useBooleanFlagValue('hide_asset_approvals', false);
}
